import React, { ChangeEvent, KeyboardEvent, useRef } from 'react';

import { IconButton, TableCell, TableRow, TextField } from '@mui/material';
import { AddCircle } from '@mui/icons-material';
import { Ingredient } from '../../services/api/models';

interface IngredientAddRowProps {
  showSort?: boolean,
  onAdd?: (ingredent: Ingredient) => void;
}

export function IngredientAddRow(props: IngredientAddRowProps) {
  const [amount, setAmount] = React.useState('');
  const [unit, setUnit] = React.useState('');
  const [name, setName] = React.useState('');

  const inputRef = useRef<HTMLInputElement>();

  const handleAmountChange = (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    setAmount(event.target.value)
  };

  const handleUnitChange = (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    setUnit(event.target.value)
  };

  const handleNameChange = (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    setName(event.target.value)
  };

  const handleAddEvent = () => {
    const ingredient: Ingredient = {
      amount: amount,
      unit: unit,
      name: name,
      original_text: null,
    };

    if (props.onAdd) {
      props.onAdd(ingredient);
    }

    reset();
  }

  const enterHandler = (event: KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    if(event.key == 'Enter') {
      event.preventDefault();
      handleAddEvent();
    }
 }

 const reset = () => {
  setAmount('')
  setUnit('')
  setName('');

  // refocus on amount field
  if (inputRef && inputRef.current) {
    inputRef.current.focus();
  }
};

 return (
  <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 }}} >
    <TableCell align='left' sx={{padding: 0, width: 0}}>
    </TableCell>
    <TableCell align="left">
      <TextField id='amount' variant='outlined' size='small' value={amount} inputRef={inputRef} onChange={handleAmountChange} InputProps={{ onKeyDown: enterHandler }}/>
    </TableCell>
    <TableCell align="left">
    <TextField id='unit' variant='outlined' size='small' value={unit} onChange={handleUnitChange} InputProps={{ onKeyDown: enterHandler }}/>
    </TableCell>
    <TableCell align="left">
    <TextField id='name' variant='outlined' size='small' value={name} onChange={handleNameChange} InputProps={{ onKeyDown: enterHandler }} />
    </TableCell>
    { props.showSort &&
    <TableCell align='left'>
    </TableCell>
    }
    <TableCell align='right' sx={{padding: 0, width: 0}}>
      <IconButton color="primary" aria-label="add ingredient" component="span" size='small' onClick={handleAddEvent}>
        <AddCircle fontSize='small'/>
      </IconButton>
    </TableCell>
  </TableRow>
 )
}
